<div class="modal-header">
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
	
</div>
<div  class="modal-footer" >
	<button mat-raised-button type="button"
			color="accent"
			(click)="aceptModal()"			
			style="min-height: 36px; position: inherit; transform: translateY(0)">
		<ng-container >
			Send Invoice
		</ng-container>
	</button>
	<button mat-raised-button type="button" style="margin-left: 10px!important;" (click)="close()" >
	  Cancel
	</button>
</div>
<div class="modal-body">
    <!-- Loader spinner begins -->
    <div *ngIf="!data" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark">
    </div>
    <!-- Loader spinner ends -->
	<div class="pdf-viewer-controls-wrap">

		<div class="pdf-viewer-controls row">
		  <div class="pdfv-control col-8" *ngIf="renderText">
			Search:
			<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery"
			  (input)="searchQueryChanged($event.target.value)" (keyup.enter)="searchQueryChanged(queryInp.value)">
			</div>
			<div class="col-2">Total Pages:{{totalPages}}</div>
			<div class="col-2">
				<span matTooltip="Zoom Out" > <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Zoom In" > <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc()"></i> </span>
				<span *ngIf="!isMobile" style="margin-left: 5px;" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF()"></i> </span>
				<span *ngIf="isMobile" style="margin-left: 5px;" matTooltip="Pdf"> <i class="fa fa fa-file-pdf fa-lg" aria-hidden="true" (click)="printPDF()"></i> </span>
				
				<span *ngIf="invoiceNumber != undefined" style="margin-left: 5px;" matTooltip="Download"><i class="fa fa-download fa-lg" aria-hidden="true"  (click)="downloadPDF()"></i> </span>
			</div>

		</div>
	  </div>
	  <div class="pdf-viewer-viewer-window">
		<pdf-viewer *ngIf="data" [src]="path" [downloadFileName]="name" [render-text]="renderText" [render-text-mode]="renderTextMode" [rotation]="rotation"
		[zoom]="zoom" [zoom-scale]="zoomScale" [original-size]="originalSize" [fit-to-page]="fitToPage"
		[show-all]="showAll" [autoresize]="autoresize" (after-load-complete)="callBackFn($event)"  [download]="true">
		 (error)="onError($event)" (on-progress)="onProgress($event)">
	  </pdf-viewer>

	  </div>
</div>
